(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ModalContext = mod.exports;
  }
})(this, function (exports, _react) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });


  /*
    Creates a context with default value
  
    The defaultValue argument is only used by a Consumer when it does not have a
    matching Provider above it in the tree. This can be helpful for testing
    components in isolation without wrapping them.
  
    See: https://reactjs.org/docs/context.html
  */

  var ModalContext = (0, _react.createContext)({
    modalComponent: null,
    props: {},
    showModal: function showModal() {},
    closeModal: function closeModal() {}
  });

  exports.default = ModalContext;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/ModalManager/ModalContext.js
// module id = 862
// module chunks = 1